
export default {
  languageName: {
    fi: () => "suomeksi",
    sv: () => "på svenska",
    en: () => "in English"
  },
  mainContentLinkText: () => "Siirry suoraan sisältöön",
  verification: {
    cancelButtonText: () => "Keskeytä"
  },
  cancelConfirmation: {
    title: () => "Haluatko keskeyttää?",
    body: () => "Jos keskeytät kirjautumisen, et voi jatkaa asiointia palvelussa.",
    yes: () => "Keskeytä",
    no: () => "Peruuta"
  },
  authenticationCancelError: {
    title: () => "Tunnistautuminen keskeytettiin",
    body: () => "Antamiasi tietoja ei välitetty."
  },
  loggedOut: {
    title: () => "Sinut on kirjattu ulos palvelusta",
    body: () => "Halutessasi voit kirjautua palveluun uudestaan.",
    close: () => "Sulje"
  },
  footer: {
    dataprotectionLinkText: () => "Tietosuoja OP:ssa",
    accessibilityLinkText: () => "Saavutettavuusseloste",
    accessibilityLinkTarget: () => "https://www.op.fi/saavutettavuus/tunnistautuminen-saavutettavuusseloste",
    termsLinkText: () => "Käyttöehdot",
    copyrightText: () => "© OP Pohjola"
  },
  applicationError: {
    title: () => "Häiriö palvelussa, pahoittelemme",
    body: () => "Palvelu ei ole juuri nyt käytettävissä. Ole hyvä ja yritä myöhemmin uudelleen."
  },
  forbiddenError: {
    title: () => "Tunnistautuminen ei onnistunut",
    body: () => "Antamallasi tunnuksella ei voi kirjautua tähän palveluun. Tarvittaessa ota yhteyttä omaan osuuspankkiisi tai OP:n asiakaspalveluun."
  },
  passwordChangeRequired: {
    title: () => "Tunnistautuminen ei onnistu",
    body: () => "Salasanasi on vaihdettava. Vaihda salasana op.fi-palvelussa."
  },
  selectRepresentationError: {
    title: () => "Häiriö palvelussa, pahoittelemme",
    body: () => "Asiointiroolin valinta ei juuri nyt onnistu. Ole hyvä ja yritä myöhemmin uudelleen."
  },
  fethRepresentationsError: {
    title: () => "Asiointirooleja ei saatu haettua",
    body: () => "Kokeile hetken kuluttua uudestaan. Tarvittaessa ota yhteyttä omaan osuuspankkiisi tai OP:n asiakaspalveluun."
  },
  authSectionDivider: () => "TAI",
  trustnetwork: {
    title: () => "Muut tunnistustavat",
    privacyText: () => "Tunnistautumisen yhteydessä OP:lle välitetään: henkilötunnus, nimi.",
    privacyLinkText: () => "Tietosuojaseloste",
    privacyLinkTarget: () => "https://isb.op.fi/privacy-info?lang=fi"
  },
  idkaart: {
    title: () => "Kirjaudu Viron sähköisellä henkilökortilla"
  },
  representation: {
    title: () => "Valitse asiointirooli",
    titleChange: () => "Vaihda asiointirooli",
    privateCustomer: () => "Henkilöasiakkuus",
    companyCustomer: () => "Yritysasiakkuus",
    companyId: () => "Y-tunnus",
    doubleAgreement: {
      YOP: () => "(Yrityksen OP-verkkopalvelu-sopimus)",
      KOPA: () => "(Yrityspalvelut-sopimus)",
      YRVEIKKO: () => "(Yritysvakuutussopimus)",
      YDAS: () => "(Yrityksen digitaalisen asioinnin sopimus)"
    },
    search: {
      title: () => "Hae yritystä",
      placeholder: () => "Kirjoita yrityksen nimi tai Y-tunnus",
      noResults: () => "Ei hakutuloksia",
      ariaLabel: () => "Kirjoittaminen rajaa yrityslistaa automaattisesti"
    },
    back: () => "Takaisin",
    current: () => "nykyinen asiointiroolisi"
  },
  accessibility: {
    loading: () => "Ladataan",
    businessId: () => "Y-tunnus",
    welcomeMessage: {
      op: () => "Kirjaudu OP:n tunnuksilla.",
      other: () => "Kirjaudu OP:n tunnuksilla tai valitse toinen tunnistustapa."
    },
    representationlist: {
      onePersonOneCompany: () => "Valitse asiointiroolisi: henkilöasiakas tai yritysasiakas.",
      noPersonManyCompanies: () => "Valitse asiointiroolisi. Sinulla on yritysrooleja [COUNT].",
      onePersonManyCompanies: () => "Valitse asiointiroolisi: henkilöasiakas tai yritysasiakas. Sinulla on yritysrooleja [COUNT]."
    },
    languageNotification: () => "Sivun kieli vaihdettu suomeksi."
  }
}